import React from 'react';
import cx from 'classnames';
import { serializeNodes } from '@plone/volto-slate/editor/render';
import logo from './images/moniviestin_logo_small.svg';
import styles from './styles.module.scss';
import EmbedPlayer from '../../Embed/EmbedPlayer';

const View = (props) => {
  const { data } = props;
  const uid = data.href?.[0]?.UID;
  const { value } = data;
  const textPosition = data.textPosition || 'top';
  const metadata = props.metadata || props.properties;

  return (
    <div
      className={cx('block', 'featured-video-block', styles.featuretextblock, {
        [styles.textBottom]: textPosition === 'bottom',
      })}
    >
      <div className={styles.textcontent}>
        <img className={styles.logoimage} src={logo} alt="Moniviestin" />
        <div className={styles.text}>
          {value ? serializeNodes(value, () => ({}), { metadata }) : '—'}
        </div>
      </div>
      {uid && (
        <div className={styles.embed}>
          <EmbedPlayer uid={uid} type="video" />
        </div>
      )}
    </div>
  );
};

export default View;
